<template>
  <div>
    <app-title>Vonex Commissions Management</app-title>
    <v-container fluid>
      <v-row  >
        <v-col>
          <v-card>
            <v-card-title primary-title>
              <app-title>Initial Commissions</app-title>
            </v-card-title>
            <v-card-text>
              <v-container fluid>
                <v-row  >
                  <v-col md="6">Some text to go here I suppose</v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col>
          <v-card>
            <v-card-title primary-title>
              <app-title>Royalty Commissions</app-title>
            </v-card-title>
            <v-card-text>
              <v-container fluid>
                <v-row  >
                  <v-col md="6">Some text to go here I suppose</v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "home",
  props: ["userProfile", "isAuthenticated"],
  components: {},
  data() {
    return {};
  },
  methods: {},
  computed: {},
  mounted() {}
};
</script>

<style scoped>
.small {
  max-width: 100%;
  margin: 10px auto;
}
</style>